import nequi from '../assets/images/payments/nequi.png';
import mastercard from '../assets/images/payments/mastercard.png';
import visa from '../assets/images/payments/visa.png';
import codensa from '../assets/images/payments/credito-facil-codensa.png';
import alkosto from '../assets/images/payments/alkosto.png';
import billetera from '../assets/images/payments/billetera.png';
import pse from '../assets/images/payments/pse.png';
import tuya from '../assets/images/payments/tuya-pay.png';
import amex from '../assets/images/payments/amex.png';
import diners from '../assets/images/payments/diners-club.png';
import discover from '../assets/images/payments/discover.png';
import applePay from '../assets/images/payments/apple-pay.png';
import googlePay from '../assets/images/payments/google-pay.png';
import '../styles/components/PaymentMarquee.scss';

const METHODS = [
  { src: nequi, name: 'Nequi' },
  { src: mastercard, name: 'Mastercard' },
  { src: visa, name: 'Visa' },
  { src: pse, name: 'PSE' },
  { src: amex, name: 'American Express' },
  { src: applePay, name: 'Apple Pay' },
  { src: googlePay, name: 'Google Pay' },
  { src: codensa, name: 'Crédito Fácil Codensa' },
  { src: alkosto, name: 'Tarjeta Alkosto' },
  { src: tuya, name: 'Tuya Pay' },
  { src: diners, name: 'Diners Club' },
  { src: discover, name: 'Discover' },
  { src: billetera, name: 'Billetera digital' },
];

/**
 * Medios de pago en una cinta que se desplaza sola (se detiene al pasar el mouse).
 * La lista va duplicada para que el desplazamiento sea continuo.
 */
const PaymentMarquee = () => (
  <div className="PaymentMarquee" aria-label="Medios de pago aceptados">
    <div className="PaymentMarquee__track">
      {[...METHODS, ...METHODS].map(({ src, name }, i) => (
        <span className="PaymentMarquee__item" key={`${name}-${i}`} aria-hidden={i >= METHODS.length}>
          <img src={src} alt={i < METHODS.length ? name : ''} loading="lazy" />
        </span>
      ))}
    </div>
  </div>
);

export default PaymentMarquee;
